<template>
    <div class="loading">
        <div class="loading-container">
            <svg viewBox="25 25 50 50" class="circular" >
                <circle cx="50" cy="50" r="20" fill="none" class="path" ></circle>
            </svg>
            <!--<img src="./loading.gif" width="24" height="24">-->
            <p class="desc">{{title}}</p>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
import {mapGetters, mapActions} from 'vuex'
let TIMER
export default {
    name: 'loading',
    props: {
        title: {
            type: String,
            default: '正在载入...',
            // default: '加载中'
        }
    },
    methods: {
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
        loading: function(newer) {
            clearTimeout(TIMER)
            let _this = this
            if (newer) {
                TIMER = setTimeout(function() {
                    _this.setLoading(false)
                    // _this.$message.error('请求超时，请重新请求！')
                    // alert('请求超时，请重新请求！')
                }, 15000)
            } else {
                clearTimeout(TIMER)
            }
        }
    },
    computed: {
        ...mapGetters(['loading'])
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import '~common/scss/variable';
.loading {
    position: fixed;
    background: rgba(0, 0, 0, 0.2);
    width: 100%;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 10000;
    .loading-container {
        position: absolute;
        top: 50%;
        width: 100%;
        text-align: center;
        transform: translateY(-50%);
        .desc {
            line-height: 20px;
            font-size: $font-18;
            color: #409eff;
        }
    }
    .loading-container .circular {
        height: 42px;
        width: 42px;
        animation: loading-rotate 2s linear infinite;
    }
    .loading-container .path {
        animation: loading-dash 1.5s ease-in-out infinite;
        stroke-dasharray: 90, 150;
        stroke-dashoffset: 0;
        stroke-width: 2;
        stroke: #409eff;
        stroke-linecap: round;
    }
}
</style>
